// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const CarouselSlider = ((($) => {
  let slider;
  let options;
  function init() {
    slider = $('.Slider-list');
    options = {
      dots: false,
      infinite: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"></button>'
    };
    slider.slick(options);

    // slider for env
    $('.image-slider-env').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 1000,
    });

    $('.Map-legend-slider').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 1000,
    });
  }
  return {
    init,
  };
}))(jQuery);

export default CarouselSlider;



// WEBPACK FOOTER //
// ./src/static/js/modules/carousel-slider.js